import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from "react-toastify";
import configModule from '../../../config.js';

function ApplyNow({ data, onCloseHandler }) {
    const config = configModule.config();
    const [nationality, setNationality] = useState("Indian");
    const [checked, setChecked] = useState(false);
    const [cityDetails, setCityDetails] = useState([]);
    const collegeName = data?.name || "-- No college select --";
    const [isSubmit, setIsSubmit] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        course: "",
        city: "",
        answer: ""
    });

    const getCityData = async () => {
        try {
            const res = await axios.get(
                `${config.apiBaseUrl}/get-city`, {
                headers: {
                    "x-api-key": config?.apichKey
                },
            }
            );

            const data = res?.data || {};

            setCityDetails(data || []);

        } catch (err) {
            console.error("API Error:", err);

            if (err.response) {
                toast.error(err.response.data?.message || "Server error");
            } else if (err.request) {
                toast.error("No response from server");
            } else {
                toast.error("Request failed");
            }

        }

    };

    useEffect(() => {
        getCityData();
    }, []);


    const applyNow = async () => {
        if (!formData.name) return toast.error("Name is required");
        if (!formData.email) return toast.error("Email is required");
        if (!formData.mobile) return toast.error("Mobile is required");
        if (!formData.course) return toast.error("Course is required");
        if (!formData.city) return toast.error("City is required");
        if (!nationality) return toast.error("Nationality is required");

        if (parseInt(formData.answer) !== 26)
            return toast.error("Wrong answer");

        if (!checked)
            return toast.error("Please accept terms");

        setIsSubmit(true);
        try {
            const res = await axios.post(
                `${config.apiBaseUrl}/apply-now`,
                {
                    a_name: formData.name,
                    a_email: formData.email,
                    a_mobile: formData.mobile,
                    a_maincourse: formData.course,
                    a_city: formData.city,
                    a_clgname: collegeName,
                    a_nationality: nationality,
                    a_status: 1
                },
                {
                    headers: {
                        "x-api-key": config?.apichKey
                    }
                }
            );

            toast.success(res?.data?.message || "Applied successfully");

            setFormData({
                name: "",
                email: "",
                mobile: "",
                course: "",
                city: "",
                answer: ""
            });

            setIsSubmit(false);

            setTimeout(() => {
                onCloseHandler("applynow");
            }, 3000);

        } catch (err) {
            console.error("API Error:", err);

            if (err.response) {
                toast.error(err.response.data?.message || "Server error");
            } else if (err.request) {
                toast.error("No response from server");
            } else {
                toast.error("Request failed");
            }
        } finally {
            setIsSubmit(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    return (
        <div className="popup-overlay" >
            <div
                className="popup-content form-popup"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="aapnow_overlay">
                    <div className="aapnow_modal">

                        <div className="aapnow_header">
                            <h2>Apply Now</h2>
                            <span className="aapnow_close" onClick={() => onCloseHandler("applynow")}>✖</span>
                        </div>

                        <div className="aapnow_body">

                            <div className="aapnow_row">
                                <div className="aapnow_label">Enter Your Name</div>
                                <input className="aapnow_input" placeholder="First Name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange} />
                            </div>

                            <div className="aapnow_row">
                                <div className="aapnow_label">Enter Email Id</div>
                                <input className="aapnow_input" placeholder="Email Id"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange} />
                            </div>

                            <div className="aapnow_row">
                                <div className="aapnow_label">Enter Mobile No</div>
                                <input className="aapnow_input" placeholder="Mobile No."
                                    name="mobile"
                                    value={formData.mobile}
                                    onChange={handleChange} />
                            </div>

                            <div className="aapnow_row">
                                <div className="aapnow_label">Enter Main Course</div>
                                <select
                                    className="aapnow_select"
                                    name="course"
                                    value={formData.course}
                                    onChange={handleChange}
                                >
                                    <option>Select Course</option>
                                    {data?.courses?.split(",").map((item, idx) => (
                                        <option key={idx}>{item}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="aapnow_row">
                                <div className="aapnow_label">Select City</div>
                                <select
                                    className="aapnow_select"
                                    name="city"
                                    value={formData.city}
                                    onChange={handleChange}
                                >
                                    <option>Select City</option>
                                    {cityDetails && cityDetails.map((item, idx) => (
                                        <option key={idx}>{item?.city}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="aapnow_row">
                                <div className="aapnow_label">College Name</div>
                                <input className="aapnow_input aapnow_disabled text-uppercase" title={collegeName} value={collegeName} disabled />
                            </div>

                            <div className="aapnow_row">
                                <div className="aapnow_label">Nationality</div>

                                <div className="radio_worm_wrapper">

                                    <input
                                        id="indian"
                                        type="radio"
                                        name="nat"
                                        value="Indian"
                                        checked={nationality === "Indian"}
                                        onChange={(e) => setNationality(e.target.value)}
                                    />
                                    <label htmlFor="indian">
                                        <span></span>Indian
                                    </label>

                                    <input
                                        id="other"
                                        type="radio"
                                        name="nat"
                                        value="Other"
                                        checked={nationality === "Other"}
                                        onChange={(e) => setNationality(e.target.value)}
                                    />
                                    <label htmlFor="other">
                                        <span></span>Other Country
                                    </label>

                                    {/* Worm animation */}
                                    <div className="worm">
                                        {Array.from({ length: 30 }).map((_, i) => (
                                            <div key={i} className="worm__segment"></div>
                                        ))}
                                    </div>

                                </div>
                            </div>

                            <div className="aapnow_row">
                                <div className="aapnow_label">What is 14 + 12 = ?</div>
                                <input className="aapnow_input" placeholder="Enter the Result."
                                    name="answer"
                                    value={formData.answer}
                                    onChange={handleChange} />
                            </div>

                            <div className="aapnow_checkbox">
                                <label className='cursor-pointer'>
                                    <div className="checkbox-wrapper-23">
                                        <input
                                            type="checkbox"
                                            id="check-23"
                                            checked={checked}
                                            onChange={(e) => setChecked(e.target.checked)}
                                        />

                                        <label htmlFor="check-23" style={{ "--size": "30px" }}>
                                            <svg viewBox="0 0 50 50">
                                                <path d="M5 30 L 20 45 L 45 5"></path>
                                            </svg>
                                        </label>
                                    </div>
                                    I agree with Campushunt.in Terms and conditions and Privacy Policy.
                                </label>
                            </div>
                            <hr />
                            <button className="aapnow_submitpp al_submit_btn" onClick={applyNow} disabled={isSubmit}>
                                {isSubmit ? "Submitting..." : "Submit"}
                            </button>

                        </div>
                    </div>
                </div>
            </div>

            <ToastContainer />
        </div>
    )
}

export default ApplyNow
